/*
FEATURE: corso-checkout-plus      STATUS: optional
COST: 2,124 B JS direct (when enabled)
PROVIDES: Keeps the pre-rendered Corso Shipping Protection row priced correctly until Corso hydrates, and collapses it when Corso never loads
REQUIRES: Corso Checkout+ app embed enabled; Corso shop metafields readable in Liquid
HOOKS: snippets/dynamic-cart-footer.liquid render 'corso-checkout-plus'; layout/theme.liquid settings.enable_corso_checkout_plus preconnect
SETTINGS: settings.enable_corso_checkout_plus
REMOVE: docs/optional-features/corso-checkout-plus.md
*/
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { CorsoCheckoutPlus } from '@/scripts/optional/corso-checkout-plus'

q.safeDefineElement(CorsoCheckoutPlus)
